import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import SearchPicker, { fetchCustomers } from "@/components/sales/SearchPicker";

export default function SupplierPickDialog({ suppliers, count, busy, onClose, onPick }) {
  const [sel, setSel] = useState(null);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="so-supplier-dialog">
        <DialogHeader><DialogTitle>İthalat Sipariş Talebi · Cari Seç</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">{count} kalem seçili. {suppliers.length > 1 ? `Seçili ürünlerin varsayılan carileri farklı (${suppliers.map((s) => s.name).join(", ")}).` : "Seçili ürünlerin bir kısmında varsayılan cari yok."} Tek talep oluşturmak için cari seçin.</p>
        <div className="flex flex-wrap gap-2">{suppliers.map((s) => <Button key={s.id} size="sm" variant={sel?.id === s.id ? "default" : "outline"} onClick={() => setSel(s)} data-testid={`so-supplier-opt-${s.id}`}>{s.name}</Button>)}</div>
        <SearchPicker placeholder="Başka cari ara (ad / kod)" fetcher={fetchCustomers} testid="so-supplier-search" onPick={(c) => setSel({ id: c.id, name: c.title })}
          render={(c) => <div className="text-[13px]"><span className="font-mono">{c.code}</span> {c.title}</div>} />
        {sel && <div className="text-sm" data-testid="so-supplier-selected">Seçilen: <b>{sel.name}</b></div>}
        <Button disabled={!sel || busy} onClick={() => onPick(sel)} className="bg-blue-600 hover:bg-blue-700" data-testid="so-supplier-confirm">Talebi Oluştur</Button>
      </DialogContent>
    </Dialog>
  );
}
